module.exports = __webpack_public_path__ + "img/menu.abcd86b3.png";